import * as React from "react";
import DetailGrid, { DetailGridItem } from "common/components/controls/DetailGrid";
import DetailGroup from "common/components/controls/DetailGroup";
import { formatDate } from "common/utils/FmtDate";
import { Hostovani } from "common/api/Evidence/Clenove/HostovaniDlouhodoba";
import HU from "common/utils/HostovaniDlouhodobaUtils";

interface SpravniPoplatekProps {
    hostovani: Hostovani;
    je_to_host_klub: boolean;
}


class SpravniPoplatek extends React.PureComponent<SpravniPoplatekProps> {
    render() {
        const { hostovani, je_to_host_klub } = this.props;

        const zobrazit = hostovani.stav !== HU.Stav_Zamitnuto && je_to_host_klub;

        const itemsPlatba: DetailGridItem[] = [
            { label: 'Částka', content: hostovani.popl_castka + ',- Kč' },
            { label: 'Zaplacen dne', content: formatDate(hostovani.popl_dat_platby) },
        ];

        const itemsDispozice: DetailGridItem[] = [
            { label: 'Částka', content: hostovani.popl_castka + ',- Kč' },
            { label: 'Číslo účtu', content: hostovani.popl_cis_uctu },
            { label: 'Variabilní symbol', content: hostovani.popl_var_sym },
            { label: 'Specifický symbol', content: hostovani.popl_spec_sym },
        ];
        if (zobrazit) {
            if (hostovani.stav >= HU.Stav_ZaplaceniPopl) {
                return <DetailGroup title="Správní poplatek za podání přestupu">
                    {hostovani.stav === HU.Stav_ZaplaceniPopl
                        ? <DetailGrid items={itemsDispozice} labelXS={4} />
                        : <DetailGrid items={itemsPlatba} labelXS={4} />
                    }
                </DetailGroup>;
            }
        }

        return null;
    }
}

export default SpravniPoplatek;